export default __webpack_public_path__ + "static/media/template1.f55fc581.png";